import {getStartOfDay} from '../../../library/dates';
import {TLectureTimeGroup, TTimetableItem} from '../../../redux/timetable/timetable.type';

export const byWeight = (a: TTimetableItem, b: TTimetableItem) => (a.weight ?? 0) - (b.weight ?? 0);

export const getSlotKey = (g: Pick<TLectureTimeGroup, 'tsid' | 'rawTime'>) => g.tsid ?? g.rawTime;

export type DropPosition = {targetTsid: number; targetDayKey: number; order: number[]};
export type DropIndicator = {slotKey: number; idx: number};

export const computeDropIndicator = (
    activeId: number | null,
    overId: number | null,
    groups: TLectureTimeGroup[]
): DropIndicator | null => {
    if(activeId == null || overId == null || activeId === overId) return null;
    for(const g of groups) {
        const key = getSlotKey(g);
        const itemIds = g.lectures.map(l => l.ttid);
        const activeIdx = itemIds.indexOf(activeId);
        const idx = overId === key ? itemIds.length : itemIds.indexOf(overId);
        if(idx < 0) continue;
        if(activeIdx >= 0 && idx === activeIdx + 1) return null;
        return {slotKey: key, idx};
    }
    return null;
};

export const computeDropPosition = (
    draggedTtid: number,
    overId: number,
    lecturesByDay: Record<number, TTimetableItem[]>
): DropPosition | null => {
    const allLectures = Object.values(lecturesByDay).flat();
    const overLecture = allLectures.find(l => l.ttid === overId);
    const dropTarget = overLecture ?? allLectures.find(l => l.tsid === overId || l.time === overId);
    if(!dropTarget) return null;

    const targetTsid = dropTarget.tsid;
    if(targetTsid == null) return null;
    const targetDayKey = targetTsid ? getStartOfDay(dropTarget.time) : 0;

    const slot = (lecturesByDay[targetDayKey] ?? [])
        .filter(l => l.tsid === targetTsid)
        .sort(byWeight);

    const others = slot.filter(l => l.ttid !== draggedTtid).map(l => l.ttid);
    const insertIdx = overLecture ? others.indexOf(overId) : others.length;
    const safeIdx = insertIdx === -1 ? others.length : insertIdx;
    const order = [...others.slice(0, safeIdx), draggedTtid, ...others.slice(safeIdx)];

    const currentOrder = slot.map(l => l.ttid);
    if(currentOrder.length === order.length && currentOrder.every((id, i) => id === order[i])) return null;

    return {targetTsid, targetDayKey, order};
};
